module.exports = __webpack_public_path__ + "img/png.fe72698b.png";